import React from 'react';
import {
  StyledInput,
  StyledLabel,
  StyledButton,
  StyledWrapper,
  StyledAsterisk,
  StyledInputIcon,
  StyledFormGroup,
  InputErrorLabel,
  InputFooterLabel,
  StyledDescription,
} from 'components/Inputs/TextInput/TextInput.styled';
import { bool, func, node, number, string, oneOfType } from 'prop-types';

/**
 * @param {{
 * name: string,
 * value: string,
 * inputId: string,
 * caption: string,
 * inputIcon: node,
 * onBlur: Function,
 * tabIndex: number,
 * disabled: boolean,
 * inputType: string,
 * onClick: Function,
 * buttonText: string,
 * onChange: Function,
 * isInvalid: boolean,
 * isRequired: boolean,
 * placeholder: string,
 * description: string,
 * errorMessage: string,
 * footerMessage: string,
 * disableAutoComplete: boolean,
 * }} param
 */
function TextInput({
  name,
  value,
  onBlur,
  inputId,
  caption,
  onClick,
  onChange,
  tabIndex,
  inputIcon,
  placeholder,
  errorMessage,
  disabled = false,
  description = '',
  buttonText = null,
  isInvalid = false,
  marginBottom = 15,
  footerMessage = '',
  isRequired = false,
  inputType = 'text',
  disableAutoComplete = false,
}) {
  const hasInputIcon = inputIcon !== undefined;
  const hasError = errorMessage?.length > 0;
  const invalidInput = isInvalid || hasError;
  const props = {};
  if (disableAutoComplete) {
    props.autoComplete = 'new-password';
  }

  return (
    <StyledFormGroup $marginBottom={marginBottom}>
      <StyledLabel htmlFor={inputId}>{caption}</StyledLabel>
      {isRequired ? <StyledAsterisk>*</StyledAsterisk> : null}
      {description ? (
        <StyledDescription>{description}</StyledDescription>
      ) : null}
      <StyledWrapper>
        <StyledInput
          {...props}
          name={name}
          id={inputId}
          value={value}
          onBlur={onBlur}
          type={inputType}
          onChange={onChange}
          tabIndex={tabIndex}
          disabled={disabled}
          placeholder={placeholder}
          $isInvalid={invalidInput}
          $hasInputIcon={hasInputIcon}
        />
        {buttonText ? (
          <StyledButton disabled={disabled} onClick={onClick}>
            {buttonText}
          </StyledButton>
        ) : null}
        {inputIcon ? <StyledInputIcon>{inputIcon}</StyledInputIcon> : null}
        {footerMessage ? (
          <InputFooterLabel>{footerMessage}</InputFooterLabel>
        ) : null}
        {errorMessage ? (
          <InputErrorLabel>{errorMessage}</InputErrorLabel>
        ) : null}
      </StyledWrapper>
    </StyledFormGroup>
  );
}

TextInput.propTypes = {
  name: string,
  onBlur: func,
  onClick: func,
  onChange: func,
  disabled: bool,
  inputId: string,
  caption: string,
  isInvalid: bool,
  inputIcon: node,
  tabIndex: number,
  isRequired: bool,
  inputType: string,
  buttonText: string,
  placeholder: string,
  description: string,
  errorMessage: string,
  disableAutoComplete: bool,
  value: oneOfType([string, number]),
};

export default TextInput;
